import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AccessGuard } from '../guards/access.guard'
import { ServicesResolver } from './services/services.resolver'
import { PermissionGuard } from '../guards/permission.guard'
import { GROUPS_PRICING } from '../constants/pricing'
import { ADMIN_GROUP } from '@sauna-net/dto'
import { camerasAvailabilityGuard } from './cameras/cameras-availability'

const routes: Routes = [
  {
    path: '',
    loadChildren: async () => (await import('./dashboard/dashboard.module')).DashboardModule,
    data: { requiresLogin: true },
    canActivate: [AccessGuard],
  },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  {
    path: 'cameras',
    canMatch: [camerasAvailabilityGuard],
    loadChildren: () => import('./cameras/cameras.module').then(m => m.CamerasModule),
    data: { requiresLogin: true },
    canActivate: [AccessGuard],
  },
  {
    path: 'harvia',
    loadChildren: () => import('./harvia/harvia.module').then(m => m.HarviaModule),
    data: { requiresLogin: true },
    canActivate: [AccessGuard],
  },
  {
    path: 'wholesale',
    loadChildren: () => import('./wholesale/wholesale.module').then(m => m.WholesaleModule),
    data: { requiresLogin: true },
    canActivate: [AccessGuard],
  },
  {
    path: 'services',
    loadChildren: () => import('./services/services.module').then(m => m.ServicesModule),
    data: { requiresLogin: true },
    canActivate: [AccessGuard],
    resolve: {
      config: ServicesResolver,
    },
  },
  {
    path: 'warehouse',
    loadChildren: () => import('./warehouse/warehouse.module').then(m => m.WarehouseModule),
    data: { requiresLogin: true },
    canActivate: [AccessGuard],
  },
  {
    path: 'changelogs',
    loadChildren: () => import('./changelogs/changelogs.module').then(m => m.ChangelogsModule),
    data: { requiresLogin: true },
    canActivate: [AccessGuard],
  },
  { path: 'inventories', redirectTo: '/warehouse/inventories' },
  { path: 'pick-ups', redirectTo: '/warehouse/pick-ups' },
  { path: 'defects', redirectTo: '/warehouse/defects' },
  {
    path: 'crm',
    loadChildren: () => import('./crm/crm.module').then(m => m.CrmModule),
    data: { requiresLogin: true },
    canActivate: [AccessGuard],
  },
  {
    path: 'pricing',
    loadChildren: () => import('./pricing/pricing.module').then(m => m.PricingModule),
    data: { requiresLogin: true, permissionGroups: GROUPS_PRICING, permissionUsersKey: 'pricingAllowedUsers' },
    canActivate: [AccessGuard, PermissionGuard],
  },
  {
    path: 'administration',
    loadChildren: () => import('./offline-auth-admin/offline-auth-admin.module').then(m => m.OfflineAuthAdminModule),
    data: { requiresLogin: true, permissionGroups: [ADMIN_GROUP], permissionUsersKey: 'administrationAllowedUsers' },
    canActivate: [AccessGuard, PermissionGuard],
  },
  {
    path: 'offline-auth-admin',
    redirectTo: 'administration/offline-auth',
    pathMatch: 'full',
  },
  {
    path: 'offline-auth-audit',
    redirectTo: 'administration/offline-auth-audit',
    pathMatch: 'full',
  },
  {
    path: 'synchronizer',
    redirectTo: 'administration/synchronizer',
    pathMatch: 'full',
  },
  { path: '**', loadChildren: () => import('./not-found/not-found.module').then(m => m.NotFoundModule) },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
    }),
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
